// extracted by mini-css-extract-plugin
export default {"container":"LoadingOverlay_container__v+WDU","show":"LoadingOverlay_show__jiszk"};